import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ec4af6ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "title-block" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "main-title" }, "待看脸列表", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("添加订单")
const _hoisted_5 = { class: "biz-card" }
const _hoisted_6 = { class: "biz-card order-table" }
const _hoisted_7 = {
  key: 0,
  style: {"margin-left":"20px"}
}
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  style: {"margin-left":"20px"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1637224104587",
  class: "icon",
  viewBox: "0 0 1041 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "3351",
  width: "48",
  height: "48"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M135.714133 1024A122.1632 122.1632 0 0 1 13.653333 901.9392V122.0608A122.1632 122.1632 0 0 1 135.714133 0h779.8784A122.1632 122.1632 0 0 1 1037.653333 122.0608v779.8784A122.1632 122.1632 0 0 1 915.592533 1024H135.714133z m362.530134-300.8512L743.253333 974.813867h172.3392a72.9088 72.9088 0 0 0 72.874667-72.874667V638.685867L785.578667 435.797333 498.244267 723.1488zM62.839467 869.188267v32.768a72.9088 72.9088 0 0 0 72.874666 72.874666h539.204267L327.714133 631.125333 62.839467 869.205333z m72.874666-820.002134a72.9088 72.9088 0 0 0-72.874666 72.874667v677.5808L330.410667 555.434667l133.546666 133.546666L785.578667 360.823467 988.4672 567.125333V122.0608a72.9088 72.9088 0 0 0-72.874667-72.874667H135.714133z m130.013867 324.949334a122.1632 122.1632 0 0 1-122.0608-122.0608 122.1632 122.1632 0 0 1 122.0608-122.0608 122.1632 122.1632 0 0 1 122.043733 122.0608c0 67.328-54.818133 122.043733-122.043733 122.043733z m0-195.037867a72.9088 72.9088 0 0 0-72.874667 72.874667 72.9088 72.9088 0 0 0 72.874667 72.874666 72.9088 72.9088 0 0 0 72.874667-72.874666 72.9088 72.9088 0 0 0-72.874667-72.874667z",
    "p-id": "3352",
    fill: "#bfbfbf"
  })
], -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { style: {"font-weight":"600"} }
const _hoisted_13 = {
  key: 0,
  style: {"color":"rgb(82, 77, 77)","margin-left":"10px"}
}
const _hoisted_14 = { style: {"margin-right":"20px"} }
const _hoisted_15 = { style: {"margin-right":"20px"} }
const _hoisted_16 = { style: {"margin-right":"20px"} }
const _hoisted_17 = {
  key: 0,
  style: {"color":"#409eff"}
}
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("编辑订单")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("开始看脸")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("AI看脸")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_23 = { style: {"text-align":"right","margin-top":"20px"} }
const _hoisted_24 = { class: "height-limit" }
const _hoisted_25 = { class: "dialog-block" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("男")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("女")
const _hoisted_28 = { style: {"text-align":"center","margin-top":"10px"} }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"100%"},
  class: "upload-icon"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    t: "1637045307310",
    class: "icon",
    viewBox: "0 0 1024 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": "5087",
    width: "64",
    height: "64"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M823.424 395.296l-287.52-289.248c-3.2-3.2-6.88-5.536-10.816-7.104C521.056 97.12 516.672 96 512 96c-11.264 0-20.704 6.176-26.4 14.976l-254.4 253.952c-12.512 12.48-12.544 32.736-0.032 45.248 6.24 6.272 14.432 9.376 22.656 9.376 8.16 0 16.352-3.104 22.624-9.344L480 206.976 480 768c0 17.696 14.336 32 32 32s32-14.304 32-32L544 204.96l234.048 235.456c6.24 6.272 14.464 9.44 22.688 9.44 8.16 0 16.32-3.104 22.56-9.312C835.84 428.096 835.904 407.84 823.424 395.296z",
      "p-id": "5088",
      fill: "#bfbfbf"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M896 704c-17.696 0-32 14.304-32 32l0 128L160 864l0-128c0-17.696-14.336-32-32-32s-32 14.304-32 32l0 160c0 17.696 14.336 32 32 32l768 0c17.696 0 32-14.304 32-32l0-160C928 718.304 913.696 704 896 704z",
      "p-id": "5089",
      fill: "#bfbfbf"
    })
  ])
], -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createTextVNode("将图片拖到 "),
  /*#__PURE__*/_createElementVNode("em", null, "此处")
], -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, "jpg/png 文件不超过5张", -1))
const _hoisted_32 = { style: {"text-align":"center","margin-bottom":"30px"} }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_34 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_35 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_36 = { class: "dialog-block" }
const _hoisted_37 = { class: "batForm-table" }
const _hoisted_38 = { style: {"text-align":"center"} }
const _hoisted_39 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_40 = /*#__PURE__*/_createTextVNode("取消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_list_filter = _resolveComponent("list-filter")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("p", null, [
          _createVNode(_component_el_form, {
            model: _ctx.form,
            inline: "true",
            onsubmit: "return false"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.searchform.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchform.name) = $event)),
                    onChange: _ctx.searchOrder,
                    onKeyup: _withKeys(_ctx.searchOrder, ["enter"]),
                    placeholder: "请输入称呼或电话号码"
                  }, null, 8, ["modelValue", "onChange", "onKeyup"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _ctx.addOrderDialog
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_list_filter, {
          onGetParam: _ctx.getForm,
          orderStatus: "未看"
        }, null, 8, ["onGetParam"])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_table, { data: _ctx.orderList }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "createtime",
              width: "150"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("p", null, _toDisplayString(scope.row.groupName), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.convertDate(scope.row.createtime)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { width: "180" }, {
              default: _withCtx((scope) => [
                (scope.row.faceImgName != null)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                      _createElementVNode("img", {
                        class: "img-block",
                        src: 
                  'https://facemaster.meb.fit/api/face/getOssImage?fileName=' +
                  scope.row.faceImgName[0] +
                  '&style=image/auto-orient,1/resize,m_lfit,w_70/quality,q_90'
                
                      }, null, 8, _hoisted_8)
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_9, _hoisted_11))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { width: "300" }, {
              default: _withCtx((scope) => [
                _createElementVNode("p", null, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(scope.row.name), 1),
                  (scope.row.remark)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, "(" + _toDisplayString(scope.row.remark) + ")", 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("p", null, [
                  _createElementVNode("span", _hoisted_14, "年龄：" + _toDisplayString(scope.row.age), 1),
                  _createElementVNode("span", _hoisted_15, "身高：" + _toDisplayString(scope.row.height), 1),
                  _createElementVNode("span", _hoisted_16, "体重：" + _toDisplayString(scope.row.weight), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { width: "200" }, {
              default: _withCtx((scope) => [
                _createTextVNode(" 订单来源： " + _toDisplayString(scope.row.createUserId == "" ? "系统" : scope.row.createUserId), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, null, {
              default: _withCtx((scope) => [
                (scope.row.orderStatus == '正在看')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_17, " 正在看脸中... "))
                  : (_openBlock(), _createElementBlock("p", _hoisted_18, [
                      _createVNode(_component_el_button, {
                        onClick: ($event: any) => (_ctx.updateOrderDialog(scope.row))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_19
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: ($event: any) => (_ctx.editWorkbench(scope.row))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_20
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_component_el_button, {
                        type: "warning",
                        onClick: ($event: any) => (_ctx.editAIReporty(scope.row))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_21
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      (_ctx.haveRemoveOrder)
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            onClick: ($event: any) => (_ctx.removeOrder(scope.row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_22
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_component_el_pagination, {
            currentPage: _ctx.pageNum,
            "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pageNum) = $event)),
            "page-sizes": [10, 20, 50, 100],
            "page-size": _ctx.pageSize,
            layout: "sizes, prev, pager, next",
            total: _ctx.total,
            onSizeChange: _ctx.handleSizeChange,
            onCurrentChange: _ctx.handlePageChange
          }, null, 8, ["currentPage", "page-size", "total", "onSizeChange", "onCurrentChange"])
        ])
      ], 512), [
        [_directive_loading, _ctx.tableLoading]
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.isShowDialog,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.isShowDialog) = $event)),
      title: _ctx.title,
      width: "50%",
      "before-close": _ctx.closeDialog,
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_el_form, {
              ref: "ruleForm",
              model: _ctx.form,
              rules: _ctx.rules
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  "label-width": "100px",
                  label: "所属项目组",
                  prop: "groupId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.form.groupId,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.groupId) = $event)),
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupList, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            value: item.id,
                            label: item.proGroupName
                          }, null, 8, ["value", "label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "电话号码",
                  "label-width": "100px",
                  prop: "phone"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.phone,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.phone) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "称呼",
                  "label-width": "100px",
                  prop: "name"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.name,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.name) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "年龄",
                  "label-width": "100px",
                  prop: "age"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.age,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.age) = $event)),
                      modelModifiers: { number: true }
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "性别",
                  "label-width": "100px"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, {
                      modelValue: _ctx.form.sex,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.sex) = $event)),
                      label: "1",
                      size: "large"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_26
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_el_radio, {
                      modelValue: _ctx.form.sex,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.sex) = $event)),
                      label: "2",
                      size: "large"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_27
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "面部照片",
                  "label-width": "100px",
                  prop: "fileValid"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_28, [
                      _createVNode(_component_el_upload, {
                        ref: "upload",
                        drag: "",
                        action: "",
                        "auto-upload": false,
                        limit: 5,
                        multiple: "",
                        "file-list": _ctx.fileList,
                        "on-change": _ctx.picChange
                      }, {
                        tip: _withCtx(() => [
                          _hoisted_31
                        ]),
                        default: _withCtx(() => [
                          _hoisted_29,
                          _hoisted_30
                        ]),
                        _: 1
                      }, 8, ["file-list", "on-change"]),
                      _withDirectives(_createVNode(_component_el_input, {
                        modelValue: _ctx.form.fileValid,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.fileValid) = $event))
                      }, null, 8, ["modelValue"]), [
                        [_vShow, false]
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "身高",
                  "label-width": "100px"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.height,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.height) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "体重",
                  "label-width": "100px"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.weight,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.weight) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "改善诉求",
                  "label-width": "100px"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.appeal,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.appeal) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "备注",
                  "label-width": "100px"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.remark,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.remark) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"]),
            _createElementVNode("div", _hoisted_32, [
              (_ctx.isAdd)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    loading: _ctx.addLoading,
                    type: "success",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.addUpdateOrderApi(true)))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_33
                    ]),
                    _: 1
                  }, 8, ["loading"]))
                : (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    loading: _ctx.addLoading,
                    type: "success",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.addUpdateOrderApi(false)))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_34
                    ]),
                    _: 1
                  }, 8, ["loading"])),
              _createVNode(_component_el_button, { onClick: _ctx.closeDialog }, {
                default: _withCtx(() => [
                  _hoisted_35
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title", "before-close"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.isShowBatform,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.isShowBatform) = $event)),
      title: "批量获取"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_36, [
          _createVNode(_component_el_form, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                "label-width": "100px",
                label: "订单来源"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input)
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                "label-width": "100px",
                label: "时间筛选"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    style: {"width":"100%"},
                    modelValue: _ctx.batchForm.time,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.batchForm.time) = $event)),
                    type: "日期",
                    placeholder: "请选择日期"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_37, [
                _createVNode(_component_el_table, { data: _ctx.batFormTable }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, { label: "表单生成时间" }),
                    _createVNode(_component_el_table_column, { label: "电话号码" }),
                    _createVNode(_component_el_table_column, { label: "称呼" })
                  ]),
                  _: 1
                }, 8, ["data"])
              ]),
              _createVNode(_component_el_form_item, {
                "label-width": "100px",
                label: "所属项目组",
                prop: "groupId"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.batchForm.groupId,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.batchForm.groupId) = $event)),
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupList, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          value: item.id,
                          label: item.proGroupName
                        }, null, 8, ["value", "label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_38, [
            _createVNode(_component_el_button, { type: "success" }, {
              default: _withCtx(() => [
                _hoisted_39
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, null, {
              default: _withCtx(() => [
                _hoisted_40
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}